<template>
  <div class="io-analysis-bar hideScroll">
    <!-- <h6 v-if="isAnalysis">Analyzing</h6> -->
    <v-btn-toggle
      v-if="!clipsOnly"
      mandatory
      style="width: 100% !important;"
      class="mb-3"
    >
      <v-btn
        color="primary"
        outlined
        v-tooltip="'Videon klipit ja ajat'"
        id="side-bar-video-clip"
        small
        style="flex-grow: 1 !important;"
        key="clips"
        @click="handleSideBar('clips')"
      >
        <v-icon :size="iconSize">mdi-format-list-bulleted</v-icon>
      </v-btn>
      <v-btn
        color="primary"
        outlined
        v-tooltip="'Luo klippi'"
        id="side-bar-create-clips"
        small
        style="flex-grow: 1 !important;"
        key="clipper"
        @click="handleSideBar('clipper')"
      >
        <v-icon :size="iconSize">mdi-format-horizontal-align-center</v-icon>
      </v-btn>
      <!-- <v-btn
        color="primary"
        outlined
        v-tooltip="'Tagging'"
        id="side-bar-tagging"
        small
        style="flex-grow: 1 !important;"
        :key="2"
        @click="handleSideBar('tagging')"
      >
        <v-icon :size="iconSize">mdi-pin-outline</v-icon>
      </v-btn> -->
      <v-btn
        color="primary"
        outlined
        v-tooltip="'Mittaa aika'"
        small
        v-if="!isAnalysis && !timesDisabled"
        key="timer"
        style="flex-grow: 1 !important;"
        @click="handleSideBar('timer')"
      >
        <v-icon :size="iconSize">mdi-timer-outline</v-icon>
        <v-icon size="10">mdi-plus</v-icon>
      </v-btn>
      <v-btn
        color="primary"
        outlined
        v-tooltip="'Pelin lyönnit'"
        small
        v-if="!isAnalysis && events && events.length > 0"
        key="gamehits"
        style="flex-grow: 1 !important;"
        @click="handleSideBar('gamehits')"
      >
        <v-icon :size="iconSize * 1.2">mdi-playlist-play</v-icon>
      </v-btn>
      <!-- <v-btn
        color="primary"
        outlined
        v-tooltip="'Pikatägäys'"
        id="side-bar-coding"
        small
        style="flex-grow: 1 !important;"
        key="coding"
        @click="handleSideBar('coding')"
      >
        <v-icon :size="iconSize">mdi-pin-outline</v-icon>
      </v-btn> -->
      <v-btn
        color="primary"
        outlined
        v-tooltip="'Pesistulokset data'"
        small
        v-if="isGame && video && video.external_service_id"
        key="data"
        :value="4"
        style="flex-grow: 1 !important;"
        @click="handleSideBar('data')"
      >
        <v-icon :size="iconSize">mdi-chart-donut</v-icon>
      </v-btn>
      <!-- <v-btn
        v-if="!isAnalysis"
        :value="4"
        style="flex-grow: 1 !important;"
        small
      >
        <v-icon :size="iconSize">mdi-dots-hexagon</v-icon>
      </v-btn> -->
    </v-btn-toggle>
    <VideoClips
      @setState="state = $event"
      ref="videoClips"
      v-if="state == 'clips'"
    ></VideoClips>
    <Clipper v-else-if="state == 'clipper'" @openClips="state = 'clipper'" :isAnalysis="isAnalysis"></Clipper>
    <!-- <Tagging v-else-if="state == 2 && (!template || template.id != 'manual')"></Tagging> -->
    <Timer :flat="true" v-else-if="state == 'timer'"></Timer>
    <!-- <game-lineups v-else-if="state == 4"></game-lineups> -->
    <game-lineups v-else-if="state == 'lineup'"></game-lineups>
    <!-- <game-code v-else-if="state == 'coding'"></game-code> -->
    <GameHits v-else-if="state == 'gamehits'"></GameHits>
    <GamePsData v-if="state == 'data'"></GamePsData>

    <!-- this is a v-show cause otherwise pleads to close popout would be called -->
    <!-- <add-ticks v-show="state == 2"></add-ticks> -->
    <!-- <AnalysisMap v-else></AnalysisMap> -->
    <!-- <AnalysisBarButton
      closedIcon="mdi-plus"
      openedIcon="mdi-close"
      text="CLIP"
    >
      <Clipper></Clipper>
    </AnalysisBarButton>
    <AnalysisBarButton
      closedIcon="mdi-plus"
      openedIcon="mdi-close"
      text="TIME"
    >
      <Timer></Timer>
    </AnalysisBarButton> -->
    <!-- <AnalysisBarButton
      closedIcon="mdi-plus"
      openedIcon="mdi-close"
      text="MAP"
    /> -->
    <!-- <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          style="bottom: 20px; right: 20px;"
          color="primary"
          absolute
          pill
        >
          <v-icon>mdi-plus</v-icon>
          Add clip
        </v-btn>
      </template>
      <span>Tooltip</span>
    </v-tooltip> -->
  </div>
</template>

<script>
// import AnalysisBarButton from './AnalysisBarButton.vue'
import VideoClips from './VideoClips.vue'
import Clipper from './Clipper.vue'
import Timer from './Timer.vue'
// import AnalysisMap from '@/components/maps/AnalysisMaps'
// import Tagging from '@/components/video/analysisBar/Tagging'
// import AddTicks from '@/components/ticks/AddTicks'
import GameLineups from '@/components/analysis/GameLineups'
import GameHits from '@/components/video/analysisBar/GameHits'

import { mapGetters } from 'vuex'
// import GameCode from '../../tag_views/analysis/GameCode.vue'
import GamePsData from './GamePsData.vue'

export default {
  props: ['isAnalysis', 'relevantClip', 'clipsOnly', 'isGame'],
  created() {
    if(this.clipsOnly) {
      this.state = 'clips';
      return
    }

    let sidebar = this.$route.query.sidebar
    if(sidebar) this.state = sidebar;
  },
  components: {
    // AnalysisBarButton,
    Clipper,
    VideoClips,
    Timer,
    GameLineups,
    // AnalysisMap,
    // Tagging,
    // AddTicks,
    // GameCode,
    GamePsData,
    GameHits
  },
  methods: {
    handleSideBar(e) {
      this.state = e
      this.$router.replace({ query: { ...this.$route.query, "sidebar": e }})
    },
    setShowOwn(val) {
      this.$refs.videoClips.setShowOwn(val)
    }
  },
  computed: {
    ...mapGetters('user', [
      'timesDisabled'
    ]),
    ...mapGetters('tagging', [
      'template'
    ]),
    ...mapGetters('videos', [
      'video'
    ]),
    ...mapGetters('analysis', [
      'events'
    ])
  },
  data: () => ({
    state: 'clips',
    iconSize: 15,
    chosenTags: []
  })
}
</script>

<style lang="scss" scoped>
.io-analysis-bar {
  height: 100%;
  padding: 10px;
  overflow-y: scroll;
}
</style>